import { Modal } from 'antd';
import { get } from 'lodash-es';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { AccountInviteForm } from '@form/account-invite/account-invite.form';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';

import { useAccountMembersInvite } from './account-members-invite.hook';
import { CancelButtonTitle, FooterWrapper, FormInnerWrapper, FormWrapper, InviteButton } from './account-members.style';
import AccountIcon from './assets/account.icon.svg?react';

export const AccountMembersInviteModal = () => {
  const { current } = useCurrentApplication();
  const { form, isModalOpen, isLoading, onCloseModal, onOpenModal, onFinish } = useAccountMembersInvite();

  return (
    <>
      <InviteButton icon={<AccountIcon />} type={ButtonTypeEnum.Primary} ghost onClick={onOpenModal}>
        <Text color={ColorEnum.Black100}>Invite team members</Text>
      </InviteButton>
      <Modal
        confirmLoading={false}
        open={isModalOpen}
        title={`Invite user to account "${get(current, ['account', 'name'])}"`}
        footer={
          <FooterWrapper>
            <Button key='back' type={ButtonTypeEnum.Primary} ghost onClick={onCloseModal}>
              <CancelButtonTitle>Cancel</CancelButtonTitle>
            </Button>
            <Button
              key='submit'
              loading={isLoading}
              type={ButtonTypeEnum.Primary}
              onClick={() => form.validateFields().then(onFinish)}
            >
              Create
            </Button>
          </FooterWrapper>
        }
        centered
        onCancel={onCloseModal}
        onOk={() => form.validateFields().then(onFinish)}
      >
        <FormWrapper>
          <FormInnerWrapper>
            <AccountInviteForm form={form} isLoading={isLoading} />
          </FormInnerWrapper>
        </FormWrapper>
      </Modal>
    </>
  );
};
